itsoftApp.createModule("navInstruction", ["pageLoad", "windowScroll", "windowResize"], function () {
    const module = this;

    const NavInstruction = function () {
        this.list = document.querySelector('.js-nav-side');
        this.links = this.list && this.list.querySelectorAll('[data-href]');
        this.data = {
            class: {
                active: '_active',
            },
            names: [],
            blocks: [],
        }


        this.init();
    };

    NavInstruction.prototype.getNames = function() {
        const NAV = this;

        for (const link of NAV.links) {
            NAV.data.names.push(link.dataset.href);
        }
    }

    NavInstruction.prototype.setBlocks = function() {
        const NAV = this;

        for (const name of NAV.data.names) {
            NAV.data.blocks.push(document.querySelector(`#${name}`));
        }
    }

    NavInstruction.prototype.isBlockInWindow = function (el) {
        const { top, bottom } = el.getBoundingClientRect();
        const pointTop = (top - itsoftApp.utils.getHeaderHeight()).toFixed();
        const pointBottom = (bottom - itsoftApp.utils.getHeaderHeight()).toFixed();

        return pointTop < 3 && pointBottom > 3;
    }

    NavInstruction.prototype.setCurBlock = function() {
        const NAV = this;

        for (const link of NAV.links) {
            link.classList.remove(NAV.data.class.active);
        }

        for (let index = 0; index < NAV.data.blocks.length; index++) {
            const block = NAV.data.blocks[index];
            if (NAV.isBlockInWindow(block)) {
                NAV.links[index].classList.add(NAV.data.class.active);
                break;
            }
        }
    }

    NavInstruction.prototype.onScroll = function () {
        const NAV = this;

        NAV.setCurBlock();
    };

    NavInstruction.prototype.init = function () {
        const NAV = this;

        if (NAV.list) {
            NAV.getNames();
            NAV.setBlocks();
            NAV.onScroll();

            itsoftApp.modules.pageLoad.addEvent(function () {
                itsoftApp.modules.windowResize.addEvent(NAV.onScroll.bind(NAV));
                itsoftApp.modules.windowScroll.addEvent(NAV.onScroll.bind(NAV));
            });
        }
    };

    new NavInstruction();
    module.callback = NavInstruction;
});
